import Axios from 'axios';
import Store from '../store'
import Auth from './authenticationService'

import Router from '../router'


const ApiInstance = Axios.create({
  baseURL: process.env.VUE_APP_BASE_URL + "api/",
  withCredentials: true
});


// ApiInstance.interceptors.response.use(null, (error) => {
//     if (error.config && error.response && error.response.status === 401) {
//         var refreshToken = Auth.getRefreshTokenFromStorage();
//         //console.log(refreshToken);

//         if (refreshToken) {     
//             var headers = {
//                 'Content-Type': 'application/json',
//                 'Authorization': 'Bearer ' + refreshToken
//             };

//             ApiInstance.post('user/refreshToken', {}, { headers: headers }).then((result) => {
//                 //console.log(result);
//                 error.config.headers.Authorization = 'Bearer ' + result.data.accessToken;
//                 Store.dispatch('user/setAuthenticated', { token: result.data.accessToken, user: result.data.user, refreshToken: refreshToken }).then(() => {
//                     if (Router.currentRoute.name == "login") {
//                         Router.push({ name: 'dashboard' })
//                     }
//                     error.config.__isRetryRequest = true
//                     return ApiInstance(error.config);
//                 });



//             }).catch(err => {
//                 console.log(err);
//                 //console.log("Could not refresh Token");
//                 Store.dispatch('user/setLogout').then(() => {
//                     Router.push({name: "login"});
//                 })

//             });
//         } else {
//             //console.log("else statement");

//             return Promise.reject(error);
//         }

//     } else {
//         return Promise.reject(error);
//     }


// });

// ApiInstance.interceptors.request.use(request => {
//     var token = localStorage.getItem('accessToken')
//     if(token) {
//         request.headers['Authorization'] = `Bearer ${token}`
//     }

//     return request

// })

ApiInstance.interceptors.response.use(null, async (error) => {

  if (error.config && error.response && error.response.status === 401) {
    var response = error.response;

    if (response) {
      if (response.status === 401 && error.config && !error.config.__isRetryRequest) {

        var refreshToken = Auth.getRefreshTokenFromStorage();
        //console.log(refreshToken);

        if (refreshToken) {
          var headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + refreshToken
          };

          try {
            var result = await ApiInstance.post('user/refreshToken', {}, { headers: headers })
            //console.log(result);

          } catch (authError) {
            //console.log(authError);
            await Store.dispatch('user/setLogout')
            //return Promise.reject(error)
          }

          await Store.dispatch('user/setAuthenticated', { token: result.data.accessToken, user: result.data.user, userDetails: result.data.userDetails, refreshToken: refreshToken })

          if (Router.currentRoute.name == "login") {
            Router.push({ name: 'dashboard' })
          }
          error.config.headers.Authorization = 'Bearer ' + result.data.accessToken;
          // retry the original request
          error.config.__isRetryRequest = true
          return ApiInstance(error.config)

          // ApiInstance.post('user/refreshToken', {}, { headers: headers }).then((result) => {
          //     //console.log(result);
          //     error.config.headers.Authorization = 'Bearer ' + result.data.accessToken;
          //     Store.dispatch('user/setAuthenticated', { token: result.data.accessToken, user: result.data.user, refreshToken: refreshToken }).then(() => {
          //         if (Router.currentRoute.name == "login") {
          //             Router.push({ name: 'dashboard' })
          //         }
          //         return ApiInstance.request(error.config);
          //     });



          // }).catch(err => {
          //     console.log(err);
          //     //console.log("Could not refresh Token");
          //     Store.dispatch('user/setLogout').then(() => {
          //         Router.push({ name: "login" });
          //     })

          // });
        } else {
          //console.log("else statement");

          return Promise.reject(error);
        }
      }
    }



  } else {
    return Promise.reject(error);
  }

})





export default ApiInstance;